import React from 'react';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
interface MetricCardProps {
  label: string;
  value: string | number;
  icon: React.ReactNode;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  className?: string;
}
export function MetricCard({
  label,
  value,
  icon,
  trend,
  className = ''
}: MetricCardProps) {
  return <div className={`bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md hover:border-gray-300 transition-all ${className}`} data-id="element-32">
      <div className="flex items-start justify-between mb-4" data-id="element-33">
        <div className="p-2.5 bg-blue-50 rounded-lg" data-id="element-34">{icon}</div>
        {trend && <div className={`flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-md ${trend.isPositive ? 'text-green-700 bg-green-50' : 'text-red-700 bg-red-50'}`} data-id="element-35">
            {trend.isPositive ? <TrendingUpIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-36" /> : <TrendingDownIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-37" />}
            <span data-id="element-38">{Math.abs(trend.value)}%</span>
          </div>}
      </div>
      <div data-id="element-39">
        <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-2" data-id="element-40">
          {label}
        </p>
        <p className="text-3xl font-bold text-gray-900 tracking-tight" data-id="element-41">
          {value.toLocaleString()}
        </p>
      </div>
    </div>;
}